<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.875 11.7188V20.3125C21.875 21.1754 21.1754 21.875 20.3125 21.875H5.46875C4.6058 21.875 3.90625 21.1754 3.90625 20.3125V11.7188M12.5 5.07812C12.5 3.56797 11.2758 2.34375 9.76562 2.34375C8.25547 2.34375 7.03125 3.56797 7.03125 5.07812C7.03125 6.58828 8.25547 7.8125 9.76562 7.8125C10.5307 7.8125 12.5 7.8125 12.5 7.8125M12.5 5.07812C12.5 5.82317 12.5 7.8125 12.5 7.8125M12.5 5.07812C12.5 3.56797 13.7242 2.34375 15.2344 2.34375C16.7445 2.34375 17.9688 3.56797 17.9688 5.07812C17.9688 6.58828 16.7445 7.8125 15.2344 7.8125C14.4693 7.8125 12.5 7.8125 12.5 7.8125M12.5 7.8125V21.875M3.51563 11.7188H22.2656C22.9128 11.7188 23.4375 11.1941 23.4375 10.5469V8.98438C23.4375 8.33717 22.9128 7.8125 22.2656 7.8125H3.51562C2.86842 7.8125 2.34375 8.33717 2.34375 8.98438V10.5469C2.34375 11.1941 2.86842 11.7188 3.51563 11.7188Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGift',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
